import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDailyAverageInitialState } from '../../services/dashboard/DailyAverageDataService';

const initialState: {
  data: any[] | undefined;
  loading: boolean;
  error: any | undefined;
  rawData: any[] | undefined;
  startDate: Date | null;
  endDate: Date | null;
  aggregate: string | null;
  viewType: string | null;
} = {
  data: undefined,
  loading: false,
  error: undefined,
  rawData: undefined,
  startDate: null,
  endDate: null,
  aggregate: null,
  viewType: null,
};

const DailyAverageDataSlice = createSlice({
  name: 'dailyAverageDataSlice',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = undefined;
      state.rawData = undefined;
      state.error = undefined;
      state.loading = false;
      state.startDate = null;
      state.endDate = null;
      state.aggregate = null;
    },
    setDateRangeAndAggregate: (state, action) => {
      const { startDate, endDate, aggregate } = action.payload;
      state.startDate = startDate;
      state.endDate = endDate;
      state.aggregate = aggregate;
    },
    setViewType: (state, action) => {
      const { viewType } = action.payload;
      state.viewType = viewType;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyAverageInitialStateAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDailyAverageInitialStateAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.rawData = action.payload;
      })
      .addCase(fetchDailyAverageInitialStateAsync.rejected, (state) => {
        state.loading = false;
      });
  },
});

// Async thunk to fetch the initial state data
export const fetchDailyAverageInitialStateAsync = createAsyncThunk(
  'dailyAverageDataSlice/fetchInitialState',
  async ({
    assetId,
    startDate,
    endDate,
    rodlift,
  }: {
    assetId: string;
    startDate: Date;
    endDate: Date;
    rodlift?: boolean;
  }) => {
    const aggregate = '1d';
    const aggregateMethod = 'mean';
    const response = await fetchDailyAverageInitialState(
      assetId,
      startDate,
      endDate,
      aggregate,
      aggregateMethod,
      rodlift,
    );
    return response;
  },
);

export const { setInitialState, setDateRangeAndAggregate, setViewType } = DailyAverageDataSlice.actions;

export default DailyAverageDataSlice.reducer;
